import constants from "../constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const {
  GET_ACHIEVEMENTS, GET_ACHIEVEMENTS_SUCCESS, GET_ACHIEVEMENTS_ERROR,
  ADD_ACHIEVEMENT, ADD_ACHIEVEMENT_SUCCESS, ADD_ACHIEVEMENT_ERROR,
  EDIT_ACHIEVEMENT, EDIT_ACHIEVEMENT_SUCCESS, EDIT_ACHIEVEMENT_ERROR,
  DELETE_ACHIEVEMENT, DELETE_ACHIEVEMENT_SUCCESS, DELETE_ACHIEVEMENT_ERROR
} = constants;

const initialState = { loading: false, achievements: [], message: '', error: '' }

export const achievementsReducer = (state = initialState, action) => {
  const { type, achievements, message, error } = action;
  switch (type) {
    case GET_ACHIEVEMENTS:
    case ADD_ACHIEVEMENT:
    case EDIT_ACHIEVEMENT:
    case DELETE_ACHIEVEMENT:
      return { ...state, loading: true, error: '', message: '' }

    case GET_ACHIEVEMENTS_SUCCESS:
      return { ...state, loading: false, achievements }
    case ADD_ACHIEVEMENT_SUCCESS:
    case EDIT_ACHIEVEMENT_SUCCESS:
    case DELETE_ACHIEVEMENT_SUCCESS:
      return { ...state, loading: false, message: successHandle(message) }

    case GET_ACHIEVEMENTS_ERROR:
    case ADD_ACHIEVEMENT_ERROR:
    case EDIT_ACHIEVEMENT_ERROR:
    case DELETE_ACHIEVEMENT_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
